import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import request from  './api/request'
import less from 'less'
import './assets/css/reset.css'
import './assets/css/ant.css'
import './assets/css/transition.css'
import './assets/css/fonts/iconfont.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './registerServiceWorker'
import './common/css/com.css'
import * as echarts from 'echarts'
import ElementUI from 'element-ui'
import {Message, MessageBox} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueResource from 'vue-resource'
import '@/common/js/index.js'


Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(Antd)
Vue.use(less)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$request = request
Vue.prototype.$bus = new Vue()
Vue.prototype.$Echart = echarts
Vue.prototype.$message=Message
Vue.prototype.$confirm=MessageBox.confirm;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/* 修改浏览器的标题title */
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title === undefined ? '迪勤科技' : to.meta.title
  next()
})
